import AjaxFormSubmission from '../class/AjaxFormSubmission';
import Countries from '../class/Countries';
import ValidateForm from "../class/ValidateForm";

let userLang = document.documentElement.lang;

/**************************************************************************************
 * CONTACT FORMS
 /************************************************************************************/

new Countries('#country', '.form-msg', '#province').init();
const country2 = document.getElementById("country_2");
const province2 = document.getElementById("country_2");
if(country2 != null && province2!=null) {
  new Countries('#country_2', '.form-msg', '#province_2').init();
}


//INTERNATIONAL SALES
if (document.querySelector('[name="contact-sales-international-form"]') != null) {
  new ValidateForm('[name="contact-sales-international-form"]', {
    'afterValidationSuccess': new AjaxFormSubmission('.contact-sales-international-form', '.form-msg', {})
  }).init();
}

//SALES AMERICA
if (document.querySelector('[name="contact-sales-america-form"]') != null) {
  new ValidateForm('[name="contact-sales-america-form"]', {
    'afterValidationSuccess': new AjaxFormSubmission('.contact-sales-america-form', '.form-msg', {})
  }).init();
}

//evocut transfer ownership
if (document.querySelector('[name="evocut-transfer-ownership-form"]') != null) {
  new ValidateForm('[name="evocut-transfer-ownership-form"]', {
    'afterValidationSuccess': new AjaxFormSubmission('.evocut-transfer-ownership-form', '.form-msg', {})
  }).init();
}

//GENERAL-INQUIRY
if (document.querySelector('[name="general-inquiry-form"]') != null) {
  new ValidateForm('[name="general-inquiry-form"]', {
    'afterValidationSuccess': new AjaxFormSubmission('.general-inquiry-form', '.form-msg', {})
  }).init();
}




/**************************************************************************************
 * CONTACT BANNER
 /************************************************************************************/

dynamicOverlay();
$(window).resize(dynamicOverlay);

function dynamicOverlay(){

  if($('.contact-us-wrapper').length && $('.contact-us-hero').length){

    var scrollbar = 10;

    if($(window).width() >= (1400 - scrollbar)){
      var height = $(window).height() - 160;
      var width = $(window).width();


      //Set absolute positioning
      if(width >= (1400 - scrollbar) && width < (1600 - scrollbar)){
        var top = 200;
      }else if(width >= (1600 - scrollbar) && width < (1920 - scrollbar)){
        var top = 367;
      }else {
        var top = 384;
      }
      var diff = (parseInt(top) + (parseInt(height) - 860))

      $('.contact-us-wrapper').css('height', height + 'px');
      $('.contact-us-hero').css('top', diff + 'px');
    }else{
      $('.contact-us-wrapper').css('height', '');
      $('.contact-us-hero').css('top', '');

    }
    setWrapperHeight();
  }
}

function setWrapperHeight(){
  if($('.contact-us-wrapper').length && $('.contact-us-hero').length){
    $('.contact-us-container').css('height', $('.contact-us-hero').height() + parseInt($('.contact-us-hero').css('top'), 10) + 40 + 'px');
  }
}

$(function(){
  $('.experts-guide-you').on('click', function(ev) {
    if (!$.contains( $(ev.target).closest('.js-click-items').find('.overview_block_subcontent__phone-contact')[0], ev.target ) &&
      (!$(ev.target).hasClass('js-goToPage'))
    ) {
      window.location.href = $(ev.target).closest('.js-click-items').find('a.btn.secondary').attr('href');
    }
  })
})

